import { BaSeDialogContext } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import download from 'downloadjs';
import { CERTIFICADO_ANEXO, CERTIFICADO_ANEXOS, PRODUTO_ENDPOINT } from './constants';

export const useFilesService = () => {
  const { backendPost, backendGetBlob } = Sebrae.useBackend();
  const { showNotification } = React.useContext(BaSeDialogContext);

  const deleteSelectedItems = React.useCallback(
    (ids, onSuccess, onAchieve, codigoProduto, isTemplatesCertificados) => {
      const produtos = `${PRODUTO_ENDPOINT}/${codigoProduto}/anexos`;
      const template = CERTIFICADO_ANEXOS;
      backendPost(
        `${
          isTemplatesCertificados ? template : produtos
        }/exclusao-lote`,
        ids,
      )
        .then(
          () =>
            showNotification({
              message: 'Registro excluído com sucesso!',
              color: 'confirmation',
            }),
          onSuccess({ resetSelection: true }),
        )
        .catch((error) =>
          showNotification({
            message: 'Não foi possível realizar a exclusão!',
            color: 'destructive',
          }),
        )
        .finally(() => onAchieve());
    },
    [backendPost, showNotification],
  );

  const downloadListaNomes = React.useCallback(
    (ids, onSuccess, onAchieve, codigoProduto, isTemplatesCertificados) => {
      const produtos = `${PRODUTO_ENDPOINT}/${codigoProduto}/anexos`;
      const template = CERTIFICADO_ANEXO;

      backendGetBlob(`${isTemplatesCertificados ? template : produtos}/nomes`, ids)
        .then((blob) => {
          download(
            blob,
            `lista_de_nomes_${codigoProduto ?? 'templates'}.txt`,
            blob.type,
          );
          showNotification({
            message: 'Download realizado com sucesso!',
            color: 'confirmation',
          });
          onSuccess({ resetSelection: true });
        })
        .catch((error) =>
          showNotification({
            message: `Erro ao efetuar download do arquivo`,
            color: 'destructive',
          }),
        )
        .finally(() => onAchieve());
    },
    [backendGetBlob, showNotification],
  );

  const downloadListaLinks = React.useCallback(
    (ids, onSuccess, onAchieve, codigoProduto, isTemplatesCertificados) => {
      const produtos = `${PRODUTO_ENDPOINT}/${codigoProduto}/anexos`;
      const template = CERTIFICADO_ANEXO;

      backendGetBlob(`${isTemplatesCertificados ? template : produtos}/links`, ids)
        .then((blob) => {
          download(
            blob,
            `lista_de_links_${codigoProduto ?? 'templates'}.txt`,
            blob.type,
          );
          showNotification({
            message: 'Download realizado com sucesso!',
            color: 'confirmation',
          });
          onSuccess({ resetSelection: true });
        })
        .catch((error) =>
          showNotification({
            message: `Erro ao efetuar download do arquivo`,
            color: 'destructive',
          }),
        )
        .finally(() => onAchieve());
    },
    [backendGetBlob, showNotification],
  );

  return { downloadListaNomes, deleteSelectedItems, downloadListaLinks };
};
